import { useEffect, useState } from "react";

const links = [
  { href: "#home", label: "首页" },
  { href: "#featured", label: "热门治愈番" },
  { href: "#categories", label: "分类片单" },
  { href: "#watchlist", label: "暖心片单" },
  { href: "#updates", label: "追更动态" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于我们" },
];

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="mx-auto flex w-full max-w-7xl items-center justify-between px-4 md:px-6 py-3 md:py-4">
        <a href="#home" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-heart-3-fill text-lg"></i>
          </span>
          <span className="font-heading text-xl md:text-2xl text-primary-600 whitespace-nowrap">
            小狗看番
          </span>
        </a>

        <div className="hidden items-center gap-1 lg:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="rounded-full px-3 py-2 text-sm font-medium text-foreground-700 hover:bg-primary-100/70 hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              {l.label}
            </a>
          ))}
        </div>

        <a
          href="#contact"
          className="hidden whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors lg:inline-flex items-center gap-1.5"
        >
          推荐好番
          <i className="ri-send-plane-line text-sm"></i>
        </a>

        <button
          onClick={() => setOpen(!open)}
          className="flex h-10 w-10 items-center justify-center rounded-full text-foreground-800 hover:bg-primary-100/70 lg:hidden"
          aria-label="打开菜单"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-background-50/95 backdrop-blur-md border-t border-background-200/70 px-4 py-3">
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-primary-100/70 hover:text-primary-700 transition-colors"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 rounded-full bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors"
            >
              推荐好番
            </a>
          </div>
        </div>
      )}
    </header>
  );
}

export default Navbar;